import { getTestId } from '@airtel/air-design-system';
export var defaultProps = Object.assign({
  heading: 'Track your order',
  subHeading: 'Check the progress of your order from here.',
  showCta: true,
  ctaTitle: 'Track Now',
  buttonType: 'secondary',
  imageUrl: 'https://assets.airtel.in/static-assets/family/images/trackorder.png'
}, getTestId('TrackOrderIngressWidgetContainer'));